import { render, staticRenderFns } from "./Eli5Black.vue?vue&type=template&id=72a76431&"
import script from "./Eli5Black.vue?vue&type=script&lang=js&"
export * from "./Eli5Black.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports